// extracted by mini-css-extract-plugin
export var externalLinkIcon = "_o0-5";
export var filledCircle = "_o0-4";
export var historyEntry = "_o0-3";
export var messageSideLeft = "_o0-1";
export var messageSideRight = "_o0-2";
export var orderTrackingCarouselWrapper = "_o0-6";
export var orderTrackingInfoContainer = "_o0-0";